// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__y6mh3","actionsCol":"EnrolledClinics_actionsCol__DfZXH"};